module.exports = __webpack_public_path__ + "static/media/getnet_logo1.d4e4c1ac.png";